import React from "react";
import { useNavigate } from "react-router-dom";
import "components/generales/Styles.css";
import Boton from "../boton/Boton";

const Cuenta = ({ cuenta, handleEliminar }) => {
  const navigate = useNavigate();

  const { nombre, tipo_cuenta, saldo, fecha_corte = new Date(), id_cuenta } = cuenta;
  return (
    <tr>
      <td>{nombre}</td>
      <td>{tipo_cuenta}</td>
      <td>{`$ ${saldo}`}</td>
      <td>{new Date(fecha_corte).toISOString().slice(0, 10)}</td>
      <td>
        <Boton
          type="button"
          buttonStyle="botonVerSolido"
          onClick={() => navigate(`/cuentas/${id_cuenta}`)}
        >
          Ver más
        </Boton>

        <Boton
          type="button"
          buttonStyle="botonEditarSolido"
          onClick={() => navigate(`/cuentas/editar/${id_cuenta}`)}
        >
          Editar
        </Boton>
        <Boton
          type="button"
          buttonStyle="botonEliminarSolido"
          onClick={() => handleEliminar(id_cuenta)}
        >
          Eliminar
        </Boton>
      </td>
    </tr>
  );
};

export default Cuenta;
